import React, { useRef, useState, useEffect } from "react";

import moment from "moment";
import { useParams } from 'react-router-dom';
import { withStyles } from "@material-ui/styles";
import API from "../Services/API";

import styles from "./Styles/BookScreenStyles";

import { Card, CardActions, CardContent, Collapse, Divider, Grid, IconButton, Paper, Typography, useTheme, Snackbar } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import LocationSelection from "./LocationSelection";
import ResourceSelection from "./ResourceSelection";
import ApptTypeSelection from "./ApptTypeSelection";
import BookScreen from "./BookScreen";
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import PersonalInformation from "./PersonalInformation";
import ConfirmationScreen from "./ConfirmationScreen";
import { Alert } from "@material-ui/lab";

const api = API.create();
const DEFAULT_APPOINTMENT_INTERVAL = "15";

const BookingProcess = (props) => {
  let { classes } = props;
  let params = props.match.params;
  const theme = useTheme();

  // Extract trailing route segments dynamically (after DOB)
  let rawSegments = [];
  if (props.location && props.location.pathname) {
    const pathSegments = props.location.pathname.split("/").filter(Boolean);
    // Path: bookappt (0) / accountId (1) / mode (2) / referralId (3) / locName (4) / locationId (5) / resourceId (6) / resourceName (7) / firstName (8) / lastName (9) / DOB (10) / ... trailing
    if (pathSegments.length > 11) {
      rawSegments = pathSegments.slice(11);
    }
  }
  if (rawSegments.length === 0) {
    rawSegments = [
      params.cellNo,
      params.email,
      params.referralType,
      params.patientId,
      params.showSpecialtyQuestions,
      params.schResourceDoctorId,
    ].filter((v) => v !== undefined && v !== "");
  }

  let segs = [...rawSegments];
  let targetDoctorId = "";
  let showSpecialtyQuestions = false;
  let patientIdVal = "";
  let referralTypeVal = "";
  let emailVal = "";
  let cellNoVal = "";

  // 1. Check if "true" or "false" is present for showSpecialtyQuestions
  const boolIndex = segs.findIndex((s) => s === "true" || s === "false");
  if (boolIndex !== -1) {
    showSpecialtyQuestions = segs[boolIndex] === "true";
    if (boolIndex + 1 < segs.length) {
      targetDoctorId = segs[boolIndex + 1];
    }
    segs = segs.slice(0, boolIndex);
  } else {
    // If no boolean flag was present, check if targetDoctorId is after patientId:
    // e.g. ["9373601298", "2", "1517120", "11"]
    if (segs.length >= 2) {
      const secondLast = segs[segs.length - 2];
      const isSecondLastPatientId = secondLast === "-1" || (/^\d+$/.test(secondLast) && parseInt(secondLast, 10) >= 1000);
      if (isSecondLastPatientId) {
        targetDoctorId = segs.pop();
      }
    }
  }

  // 2. Check if the last remaining segment is patientId
  if (segs.length > 0) {
    const last = segs[segs.length - 1];
    if (last === "-1" || (/^\d+$/.test(last) && parseInt(last, 10) >= 1000)) {
      patientIdVal = segs.pop();
    }
  }

  // 3. Pop remaining trailing segments: email, phone, referralType
  while (segs.length > 0) {
    const val = segs.pop();
    if (val.includes("@")) {
      emailVal = val;
    } else if (/^\d{7,15}$/.test(val)) {
      cellNoVal = val;
    } else {
      if (!referralTypeVal) {
        referralTypeVal = val;
      } else {
        cellNoVal = val;
      }
    }
  }
  // Specialty type is derived from the (now correctly aligned) referralTypeVal.
  // '1' = Sleep, '2' = Pulmonary — must be computed AFTER the alignment block.
  const specialtyType = referralTypeVal === '1' ? 'sleep' : referralTypeVal === '2' ? 'pulmonary' : null;

  // Also check query string (e.g. ?docid=11, ?doctorId=11, ?schResourceDoctorId=11)
  if (!targetDoctorId && props.location && props.location.search) {
    const searchParams = new URLSearchParams(props.location.search);
    targetDoctorId =
      searchParams.get("docid") ||
      searchParams.get("docId") ||
      searchParams.get("doctorId") ||
      searchParams.get("schResourceDoctorId") ||
      "";
  }
  // Also check route params
  if (!targetDoctorId) {
    if (params.schResourceDoctorId && params.schResourceDoctorId !== "-1") {
      targetDoctorId = params.schResourceDoctorId;
    } else if (params.docid && params.docid !== "-1") {
      targetDoctorId = params.docid;
    } else if (params.doctorId && params.doctorId !== "-1") {
      targetDoctorId = params.doctorId;
    }
  }


  const [dbname, setDBname] = useState(params.accountId);
  const [modes, setModes] = useState(params.mode);
  const [locationIds, setlocationId] = useState(params.locationId);
  const [locNames, setLocName] = useState(params.locName);
  const [resourceIds, setResourceId] = useState(params.resourceId);
  const [referralTypes, setReferralType] = useState(referralTypeVal);
  const [resourceNames, setResourceName] = useState(params.resourceName);
  const [showDialog, setShowDialog] = useState(true);
  let [selectedLocation, setSelectedLocation] = useState("");
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedProviderName, setSelectedProviderName] = useState("");
  const [isLocationExpanded, setLocationExpanded] = useState(true);
  const [isResourceExpanded, setResourceExpanded] = useState(false);
  const [isApptTypeExpanded, setApptTypeExpanded] = useState(false);
  const [selectedApptType, setSelectedApptType] = useState("");
  const [selectedApptTypeId, setSelectedApptTypeId] = useState("");
  const [selectedApptTypeInterval, setSelectedApptTypeInterval] = useState("");
  const [isSlotsExpanded, setSlotsExpanded] = useState(false);
  const [isInfoExpanded, setInfoExpanded] = useState(false);
  const [isConfirmExpanded, setConfirmExpanded] = useState(false);
  const [isStartTime, setStartTime] = useState("");
  const [isEndTime, setEndTime] = useState("");
  const [isSelectedDOB, setSelectedDOB] = useState("");
  const [isMoveToInfo, setMoveToInfo] = useState(false);
  const [isMoveToConfirm, setMoveToConfirm] = useState(false);
  // Only a successful submission from PersonalInformation may unlock the
  // provider step.  Field values alone can be saved when a panel is closed.
  const [isPersonalInfoComplete, setPersonalInfoComplete] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  let [successData, setSuccess] = useState(false);
  let [practiceNum, setPracticeNum] = useState("");
  let [isCellNum, setCellNum] = useState(cellNoVal);
  let [isNewPatient, setIsNewPatient] = useState("");
  // Specialty intake Q&A answers (from PersonalInformation)
  let [specialtyAnswers, setSpecialtyAnswers] = useState({});
  let [insNum, setInsNum] = useState("");
  let [isSelectRelationId, setselectRelationId] = useState("");
  let [isSelectRelationName, setselectRelationName] = useState("");
  let [isPrimaryCardHolderFname, setPrimaryCardHolderFname] = useState("");
  let [isPrimaryCardHolderLname, setPrimaryCardHolderLname] = useState("");
  let [isSelectVisitType, setSelectVisitType] = useState("");
  let [isSelectedInsName, setSelectedInsName] = useState("");
  let [isSelectedVisitReason, setSelectedVisitReason] = useState("");
  let [isSelectedInsNameValue, setSelectedInsNameValue] = useState("");
  let [isSelectedVisitReasonValue, setSelectedVisitReasonValue] = useState("");
  let [locationname, setLocationName] = useState("");
  const [accountName, setAccountName] = useState("");
  let [isModalOpened, setModalOpened] = useState(false);
  let [bookeddate, setbookedDate] = useState("");
  let [fname, setFname] = useState(params.firstName || "");
  let [dob, setdob] = useState(params.DOB || "");
  let [lname, setLname] = useState(params.lastName || "");
  let [isEmail, setpatientEmail] = useState(emailVal || "");
  let [address, setAddress] = useState("");
  const [isOpenn, setopenn] = useState(true);
  let [errorApi, seterrorAPI] = useState(false);
  let [errorSlotMsg, seterrorSlotMsg] = useState(false);
  let [referenceCall, setReferenceCall] = useState(null);
  const [isScroll, setScroll] = useState(false);
  const api = API.create();
  const useRefInput = useRef(null);
  const [showflag, setShowflag] = useState(false);
  let [fromBindExit, setFromBindExit] = useState(false);
  const [showApptTypePanel, setShowApptTypePanel] = useState(false);
  const [isAutoPopulated, setIsAutoPopulated] = useState(false);
  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);
  const handleConfirmDOB = (dob) => {
    setSelectedDOB(dob);
    // Implement any additional logic needed when DOB is confirmed
    console.log("Confirmed DOB:", dob);
    // Continue with the info expansion
    setInfoExpanded(true);
  };
  const closeSnackBar = () => {
    setOpenSnackBar(false);
  };

  useEffect(() => {
    const fetchAccountName = async () => {
      try {
        const res = await fetch(
          `https://sso.glaceemr.com/TestSSOAccess?accountId=${dbname}`
        );

        const data = await res.json();   // API returns JSON
        setAccountName(data.practicename);  // <-- get practice name
        setShowflag(true);
        console.log("Fetched account name:", data.practicename);
      } catch (err) {
        console.log("Error fetching account name", err);
      }
    };

    const fetchApptTypes = () => {
      api.getApptType({ dbname: dbname }, (res) => {
        const hasActiveApptTypes = res.status === 200 &&
          Array.isArray(res.data) &&
          res.data.some((apptType) => apptType.app_Reference_Values_isActive === true);

        if (hasActiveApptTypes) {
          setShowApptTypePanel(true);
        } else {
          setShowApptTypePanel(false);
        }
      });
    };

    if (dbname) {
      fetchAccountName();
      fetchApptTypes();
    }
  }, [dbname]);
  const show = () => {
    if (locationname.length === 0) {
      setSnackBarMessage("Please select the practice location");
      setOpenSnackBar(true);
    } else if (!isPersonalInfoComplete) {
      setSnackBarMessage("Please fill and review your information");
      setOpenSnackBar(true);
    } else if (selectedProviderName.length === 0) {
      setSnackBarMessage("Please select the Service Doctor");
      setOpenSnackBar(true);
    } else if (showApptTypePanel && selectedApptType.length === 0) {
      setSnackBarMessage("Please select the Appointment Type");
      setOpenSnackBar(true);
    } else if (bookeddate.length === 0) {
      setSnackBarMessage("Please select the slot you want to book the appointment");
      setOpenSnackBar(true);
    }
  };
  const valu = (ans) => {
    console.log(ans + "test");
    setopenn(ans);
  }
  const appointmentBooked = (success) => {
    var objReturn = JSON.stringify(JSON.parse(JSON.stringify(success)).data);
    if (JSON.parse(JSON.parse(objReturn)).isPatientExist === "None")
      setSuccess(true);
    else
      setSuccess(false);

    var practiceNumData = JSON.stringify(JSON.parse(JSON.parse(objReturn)).PracticeNum);
    if (practiceNumData.includes("Locked")) {
      seterrorSlotMsg(true);
    } else if (practiceNumData.includes("Error")) {
      seterrorAPI(true);
    }
    else {
      setPracticeNum(JSON.parse(JSON.parse(objReturn)).PracticeNum);
      seterrorAPI(false);
    }

    setModalOpened(true)
  }
  const expandLocation = () => {
    setLocationExpanded(!isLocationExpanded);
    setResourceExpanded(false);
    setApptTypeExpanded(false);
    setSlotsExpanded(false);
    setModalOpened(false);
    seterrorAPI(false);
    setInfoExpanded(false);
    setConfirmExpanded(false);
    setMoveToInfo(false);
    setScroll(false);
  }
  const expandResource = () => {
    callExit();
    setLocationExpanded(false);
    setResourceExpanded(!isResourceExpanded);
    setApptTypeExpanded(false);
    setSlotsExpanded(false);
    setModalOpened(false);
    seterrorAPI(false);
    setInfoExpanded(false);
    setConfirmExpanded(false);
    setMoveToInfo(false);
    setScroll(false);
  }
  const expandApptType = () => {
    callExit();
    setLocationExpanded(false);
    setResourceExpanded(false);
    setApptTypeExpanded(!isApptTypeExpanded);
    setSlotsExpanded(false);
    setModalOpened(false);
    seterrorAPI(false);
    setInfoExpanded(false);
    setConfirmExpanded(false);
    setMoveToInfo(false);
    setScroll(false);
  }
  const expandSlots = () => {
    setLocationExpanded(false);
    setResourceExpanded(false);
    setApptTypeExpanded(false);
    setSlotsExpanded(!isSlotsExpanded);
    setModalOpened(false);
    seterrorAPI(false);
    setInfoExpanded(false);
    setConfirmExpanded(false);
    setMoveToInfo(false);
    setScroll(true);
    callExit();
  }

  const expandInfo = () => {
    setInfoExpanded(!isInfoExpanded);
    setLocationExpanded(false);
    setResourceExpanded(false);
    setApptTypeExpanded(false);
    setSlotsExpanded(false);
    setModalOpened(false);
    seterrorAPI(false);
    setMoveToInfo(true);
    setConfirmExpanded(false);
    setScroll(false);
  }
  const expandConfirmation = () => {
    setConfirmExpanded(!isConfirmExpanded);
    setInfoExpanded(false);
    setLocationExpanded(false);
    setResourceExpanded(false);
    setApptTypeExpanded(false);
    setSlotsExpanded(false);
    setModalOpened(false);
    seterrorAPI(false);
    setScroll(false);
  }

  const resSelected = (resourceValue, dbname, resname) => {
    if (selectedProvider && selectedProvider !== resourceValue) {
      setbookedDate("");
      setStartTime("");
      setEndTime("");
    }
    setSelectedProvider(resourceValue);
    setSelectedProviderName(resname);
    setDBname(dbname);
    if (resourceValue && resourceValue.length > 0) {
      if (showApptTypePanel) {
        expandApptType();
      } else {
        expandSlots();
      }
    }
  }

  const apptTypeSelected = (apptTypeValue, apptTypeName, dbname, apptTypeInterval) => {
    setSelectedApptType(apptTypeName);
    setSelectedApptTypeId(apptTypeValue);
    setSelectedApptTypeInterval(apptTypeInterval);
    setDBname(dbname);
    expandSlots();
  }

  const locSelected = (locID, locName, dbName) => {
    setLocationName(locName);
    setSelectedLocation(locID);
    setDBname(dbName);
    setSelectedProvider("");
    setSelectedProviderName("");
    setbookedDate("");
    setStartTime("");
    setEndTime("");
    expandInfo();
  }

  const continueToInfo = (dbName, selDate, startTime, endTime) => {
    setDBname(dbName);
    setbookedDate(selDate);
    setStartTime(startTime);
    setEndTime(endTime);
    setMoveToConfirm(true);
    expandConfirmation();
  }

  const moveConfirmation = (
    lastName,
    firstName,
    cellNum,
    selectedDOB,
    selectedVisitType,
    selectedInsName,
    selectedVisitReason,
    selectedInsValue,
    selecteVistReasonData,
    isNewPatient,
    email,
    insId,
    selectRelation,
    selectRelationName,
    primaryCardHolderFname,
    primaryCardHolderLname,
    addressData,
    specialtyAnswersData) => {
    setFname(firstName);
    setLname(lastName);
    setCellNum(cellNum);
    setSelectedDOB(selectedDOB);
    setSelectVisitType(selectedVisitType);
    setSelectedInsName(selectedInsName);
    setSelectedVisitReason(selectedVisitReason);
    setSelectedInsNameValue(selectedInsValue);
    setSelectedVisitReasonValue(selecteVistReasonData);
    setIsNewPatient(isNewPatient);
    setpatientEmail(email);
    setInsNum(insId);
    setselectRelationId(selectRelation);
    setselectRelationName(selectRelationName);
    setPrimaryCardHolderFname(primaryCardHolderFname);
    setPrimaryCardHolderLname(primaryCardHolderLname);
    setAddress(addressData);
    if (specialtyAnswersData) setSpecialtyAnswers(specialtyAnswersData);
    setPersonalInfoComplete(true);
    if (bookeddate && bookeddate.length > 0) {
      setMoveToConfirm(true);
      expandConfirmation();
    } else {
      expandResource();
    }
  }
  var confirmToBook = () => {
    // Use the configured appointment-type duration. Practices without active
    // appointment types book with the standard 15-minute interval.
    const bookingInterval = showApptTypePanel && selectedApptType &&
      selectedApptTypeInterval !== null &&
      selectedApptTypeInterval !== undefined &&
      selectedApptTypeInterval !== ""
      ? selectedApptTypeInterval
      : DEFAULT_APPOINTMENT_INTERVAL;

    api.checkApptRequest(
      {
        dbname: dbname,
        Lastname: lname,
        FirstName: fname,
        dateofbirth: isSelectedDOB,
      },
      (res) => {
        if (res.status === 200) {
          let locResObj = res.data;

          if (locResObj && locResObj.includes("You already have an appointment for")) {
            let cleanLocResObj = locResObj.replace(/['"]+/g, '');
            cleanLocResObj = cleanLocResObj.replace('already have', 'may already have');// This removes any quotes from locResObj
            cleanLocResObj = cleanLocResObj.replace('appointment for', 'appointment with');// This removes any quotes from locResObj
            alert(cleanLocResObj + " Pls contact our office during normal business hours.");
            setConfirmExpanded(false); // Optionally collapse the UI
            return; // Stop further execution
          } else if (locResObj && locResObj === '"Appointment request already available"') {
            alert("An appointment request for this patient already exists. Pls contact our office during normal business hours.");
            setConfirmExpanded(false); // Optionally collapse the UI
            return; // Stop further execution
          } else {
            // Proceed with booking the appointment
            api.bookAppointment(
              dbname,
              {
                patientId: (patientIdVal && patientIdVal !== "-1" && patientIdVal !== "") ? patientIdVal : -1,
                schApptAlertEventCategoryId: 19,
                schApptChartId: -1,
                schApptAlertEventCreatedDate: moment().format("YYYY-MM-DD hh:mm:ss"),
                schApptEncounterId: -1,
                schApptAlertEventFrom: -1, //patId
                schApptAlertEVentFromPage: "Quick Book",
                schApptAlertEventHighlight: true,
                schApptMessage: "From WebPortal",
                schApptAlertEventModifiedBy: -1, //patId
                schApptAlertEventModidfiedDate: moment().format("YYYY-MM-DD hh:mm:ss"),
                schApptAlertEventParentId: -1,
                schApptPatientId: -1, //patId
                schApptPatientname: lname + " " + fname,
                patLastName: lname,
                patFirstName: fname,
                patEmail: isEmail,
                schApptHomephone: isCellNum,
                schApptAlertEVentStatus: 1,
                schApptAlertEventRefId: -1,
                schApptAlertEventTo: -1, //"resourceDoctorId"
                schApptDate: bookeddate,
                schApptStarttime: isStartTime,
                schApptEndtime: isEndTime,
                schApptInterval: bookingInterval,
                schApptLocation: selectedLocation,
                schApptResource: selectedProvider.split("@")[0],
                schApptReason: isSelectedVisitReason,
                schApptType: selectedApptTypeId ? selectedApptTypeId : -1,
                schApptTypeName: selectedApptType ? selectedApptType : (isSelectVisitType === "Video visit" ? "TeleMed" : "OfficeVisit"),
                schApptStatus: 1,
                schApptNextconsId: -1,
                schApptComments: (() => {
                  let comments = "From WebPortal";
                  if (showSpecialtyQuestions && specialtyAnswers && Object.keys(specialtyAnswers).length > 0) {
                    comments += "\nQuestions - Answers\n";
                    Object.entries(specialtyAnswers).forEach(([q, a]) => {
                      comments += `${q}: ${a || 'N/A'}\n`;
                    });
                  }
                  return comments.trim();
                })(),
                schApptLastmodifiedUserId: -100, //patId
                schApptLastmodifiedTime: moment().format("YYYY-MM-DD hh:mm:ss"),
                schApptRoomId: -1,
                schApptStatusgrpId: 1,
                h555555: 1,
                insId: isSelectedInsName,
                patientDOB: isSelectedDOB,
                reasondata: isSelectedVisitReasonValue,
                insNum: insNum.length === 0 ? -1 : insNum,
                schRelationName: isSelectRelationName,
                schRelationid: isSelectRelationId,
                schApptPrimaryCardHolder: (isPrimaryCardHolderLname + " " + isPrimaryCardHolderFname).trim(),
                patAddress: address,
              },
              (res) => {
                if (res.status === 200) {
                  let locResObj = res.data;
                  if (locResObj === 'glaceportal_failure_exception')
                    seterrorAPI(true);
                  else
                    appointmentBooked(locResObj);
                }
              }
            );
          }
        } else {
          api.bookAppointment(
            dbname,
            {
              patientId: (patientIdVal && patientIdVal !== "-1" && patientIdVal !== "") ? patientIdVal : -1,
              schApptAlertEventCategoryId: 19,
              schApptChartId: -1,
              schApptAlertEventCreatedDate: moment().format("YYYY-MM-DD hh:mm:ss"),
              schApptEncounterId: -1,
              schApptAlertEventFrom: -1, //patId
              schApptAlertEVentFromPage: "Quick Book",
              schApptAlertEventHighlight: true,
              schApptMessage: "From WebPortal",
              schApptAlertEventModifiedBy: -1, //patId
              schApptAlertEventModidfiedDate: moment().format("YYYY-MM-DD hh:mm:ss"),
              schApptAlertEventParentId: -1,
              schApptPatientId: -1, //patId
              schApptPatientname: lname + " " + fname,
              patLastName: lname,
              patFirstName: fname,
              patEmail: isEmail,
              schApptHomephone: isCellNum,
              schApptAlertEVentStatus: 1,
              schApptAlertEventRefId: -1,
              schApptAlertEventTo: -1, //"resourceDoctorId"
              schApptDate: bookeddate,
              schApptStarttime: isStartTime,
              schApptEndtime: isEndTime,
              schApptInterval: bookingInterval,
              schApptLocation: selectedLocation,
              schApptResource: selectedProvider.split("@")[0],
              schApptReason: isSelectedVisitReason,
              schApptType: selectedApptTypeId ? selectedApptTypeId : -1,
              schApptTypeName: selectedApptType ? selectedApptType : (isSelectVisitType === "Video visit" ? "TeleMed" : "OfficeVisit"),
              schApptStatus: 1,
              schApptNextconsId: -1,
              schApptComments: (() => {
                let comments = "From WebPortal";
                if (showSpecialtyQuestions && specialtyAnswers && Object.keys(specialtyAnswers).length > 0) {
                  comments += "\nQuestions - Answers\n";
                  Object.entries(specialtyAnswers).forEach(([q, a]) => {
                    comments += `${q}: ${a || 'N/A'}\n`;
                  });
                }
                return comments.trim();
              })(),
              schApptLastmodifiedUserId: -100, //patId
              schApptLastmodifiedTime: moment().format("YYYY-MM-DD hh:mm:ss"),
              schApptRoomId: -1,
              schApptStatusgrpId: 1,
              h555555: 1,
              insId: isSelectedInsName,
              patientDOB: isSelectedDOB,
              reasondata: isSelectedVisitReasonValue,
              insNum: insNum.length === 0 ? -1 : insNum,
              schRelationName: isSelectRelationName,
              schRelationid: isSelectRelationId,
              schApptPrimaryCardHolder: (isPrimaryCardHolderLname + " " + isPrimaryCardHolderFname).trim(),
              patAddress: address,
            },
            (res) => {
              if (res.status === 200) {
                let locResObj = res.data;
                if (locResObj === 'glaceportal_failure_exception')
                  seterrorAPI(true);
                else
                  appointmentBooked(locResObj);
              }
            }
          );
        }
      }
    );
  }

  const refCallMethod = (refCall) => {
    setReferenceCall(refCall);
  }
  const applyActiveClasses = () => {
    const infoCardElement = document.getElementById("infoCard");
    const reviewCardElement = document.getElementById("reviewCard");

    if (infoCardElement && reviewCardElement) {
      infoCardElement.classList.add(classes.activeColor);
      reviewCardElement.classList.add(classes.activeColor);
    }
  };
  const callExit = () => {
    if (referenceCall !== null && referenceCall.current !== null)
      referenceCall.current.click();
  }
  const bindValuesForExit = (
    lastName,
    firstName,
    cellNum,
    selectedDOB,
    selectedVisitType,
    selectedInsName,
    selectedVisitReason,
    selectedInsValue,
    selecteVistReasonData,
    isNewPatient,
    email,
    insId,
    selectRelation,
    selectRelationName,
    primaryCardHolderFname,
    primaryCardHolderLname,
    addressData,
    specialtyAnswersData) => {
    setFname(firstName);
    setLname(lastName);
    setCellNum(cellNum);
    setSelectedDOB(selectedDOB);
    setSelectVisitType(selectedVisitType);
    setSelectedInsName(selectedInsName);
    setSelectedVisitReason(selectedVisitReason);
    setSelectedInsNameValue(selectedInsValue);
    setSelectedVisitReasonValue(selecteVistReasonData);
    setIsNewPatient(isNewPatient);
    setpatientEmail(email);
    setInsNum(insId);
    setselectRelationId(selectRelation);
    setselectRelationName(selectRelationName);
    setPrimaryCardHolderFname(primaryCardHolderFname);
    setPrimaryCardHolderLname(primaryCardHolderLname);
    setAddress(addressData);
    if (specialtyAnswersData) setSpecialtyAnswers(specialtyAnswersData);
    setFromBindExit(true);

  }
  const changeDateFormat = (value) => {
    var year = "";
    var month = "";
    var day = "";
    var dateSpliter = value.split("-");
    year = dateSpliter[0];
    month = dateSpliter[1];
    day = dateSpliter[2];
    var dateConversion = new Date(year, (month - 1), day);
    var formattedDate = moment(dateConversion).format('MM/DD/YYYY');
    return formattedDate;
  }
  const changeTiming = (time) => {
    var time = time.toString().split(" ")[1];
    var time = time.toString().split(":")[0].length > 1 ? time.slice(0, (time.length - 3)) : '0' + time.slice(0, (time.length - 3));
    var time = time.toString().split(":")[0].length > 1 ? time : '0' + time;
    var time = time.toString().split(":")[1].length > 1 ? time : time.toString().split(":")[0] + ':0' + time.toString().split(":")[1];
    var time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? ' AM' : ' PM';
      time[0] = +time[0] % 12 || 12;
    }
    return time.join('');
  }

  return (
    <div>
      {!isModalOpened && (
        <Grid container xs={12} direction="column" spacing={1} style={{ width: "900px", margin: "30px auto 0" }}>


          {
            showflag && (<Typography variant="p" style={{
              textAlign: "center",
              fontSize: "24px",
              padding: "14px",
              fontWeight: "bold",
              position: "relative",
              top: "-15px",
              backgroundColor: "rgb(215, 215, 215)",
              marginLeft: "10px",
              marginRight: "10px",
              borderRadius: "15px"
            }}>
              {accountName}
            </Typography>)
          }

          <Typography variant="p" style={{
            textAlign: "center",
            fontSize: "22px",
            padding: "14px",
            fontWeight: "bold",
            position: "relative",
            top: "-15px"
          }}>
            Appointment Booking
          </Typography>

          <Paper elevation={0} square xs={5} sm={5} md={12} lg={12} style={{ background: "#f6f6f6" }}>

            <Grid item xs={12} style={{
              paddingBottom: "15px"
            }}>
              <Card style={{
                borderRadius: "0px"
              }}>
                <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandLocation} aria-expanded={isLocationExpanded}>
                  <div className={classes.titleCommon}>
                    <Typography id="locationCard" variant="span" className={classes.numberCircle}>1</Typography>
                    <div className={classes.cardTitle}>
                      <Typography variant="span"  >Choose practice location</Typography>
                    </div>
                  </div>
                </div>
                <Collapse in={isLocationExpanded} >
                  <CardContent style={{
                    marginTop: "-3%",
                  }}>
                    <LocationSelection
                      methodselection={{
                        changeSelection: locSelected.bind(this),
                        newCall: true
                      }}
                      value={{ dbname, modes, locationIds, locNames }}
                    />
                  </CardContent>
                </Collapse>
              </Card>
              {locationname.length > 0 && (
                <Paper elevation={1} style={{
                  borderRadius: "0px"
                }}>
                  {document.getElementById("locationCard") && document.getElementById("locationCard").classList.add(classes.activeColor)}
                  <Divider />
                  <Card onClick={expandLocation}>
                    <CardContent>
                      <Typography variant="span">
                        Selected location : {locationname}
                      </Typography>
                    </CardContent>
                  </Card>
                </Paper>
              )}
            </Grid>

            <Grid item xs={12} style={{
              paddingBottom: "15px"
            }}>
              <Card style={{
                borderRadius: "0px"
              }}>
                <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandInfo} aria-expanded={isInfoExpanded}>
                  <div className={classes.titleCommon}>
                    <Typography id="infoCard" variant="span" className={classes.numberCircle}>2</Typography>
                    <Typography variant="span" className={classes.cardTitle}>Your Information</Typography>
                  </div>
                </div>
                <Collapse in={isInfoExpanded} onExit={() => {
                }}>
                  <CardContent style={{
                    marginTop: "-3%",
                  }}>
                    {locationname.length === 0 && isInfoExpanded && (
                      show(),
                      setInfoExpanded(!isInfoExpanded)
                    )}
                    {locationname.length > 0 && isMoveToInfo && (
                      <PersonalInformation
                        ref={useRefInput}
                        infoScreen={{
                          moveConfirmation: moveConfirmation.bind(this),
                          newCall: true,
                          dbname: dbname,
                          refCallMethod: refCallMethod.bind(this),
                          bindValuesForExit: bindValuesForExit.bind(this),
                          valu: valu.bind(this),
                          Fname: fname,
                          Lname: lname,
                          CellNum: isCellNum,
                          selecteddob: isSelectedDOB,
                          selectVisitType: isSelectVisitType,
                          selectedInsName: isSelectedInsName,
                          selectedInsNameValue: isSelectedInsNameValue,
                          selectedVisitReason: isSelectedVisitReason,
                          selectedVisitReasonValue: isSelectedVisitReasonValue,
                          insNum: insNum,
                          selectRelationName: isSelectRelationName,
                          email: isEmail,
                          relationId: isSelectRelationId,
                          relationName: isSelectRelationName,
                          primaryCardHolderFname: isPrimaryCardHolderFname,
                          primaryCardHolderLname: isPrimaryCardHolderLname,
                          fromBindExit: fromBindExit,
                          isNewPatient: isNewPatient,
                          dobset: isOpenn ? dob : '',
                          modenew: modes,
                          patientId: patientIdVal,
                          isAutoPopulated: isAutoPopulated,
                          setIsAutoPopulated: setIsAutoPopulated,
                          showSpecialtyQuestions: showSpecialtyQuestions,
                          specialtyType: specialtyType,
                          specialtyAnswers: specialtyAnswers
                        }}
                      />
                    )}
                  </CardContent>
                </Collapse>
              </Card>
              {isSelectVisitType != undefined && isSelectVisitType != "" && fname != undefined && fname.length > 0 && (
                <Paper elevation={1} style={{
                  borderRadius: "0px"
                }}>
                  {document.getElementById("infoCard") && document.getElementById("infoCard").classList.add(classes.activeColor)}
                  <Divider />
                  <Card onClick={expandInfo}>
                    <CardContent>
                      <Typography variant="span">
                        Name : {fname} {lname}
                      </Typography>
                    </CardContent>
                  </Card>
                </Paper>
              )}
            </Grid>

            <Grid item xs={12} style={{
              paddingBottom: "15px"
            }}>
              <Card style={{
                borderRadius: "0px"
              }}>
                <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandResource} aria-expanded={isResourceExpanded}>
                  <div className={classes.titleCommon}>
                    <Typography id="doctorCard" variant="span" className={classes.numberCircle}>3</Typography>
                    <div className={classes.cardTitle}>
                      <Typography variant="span">Choose Service Doctor</Typography>
                    </div>
                  </div>
                </div>
                <Collapse in={isResourceExpanded}>
                  <CardContent style={{
                    marginTop: "-3%",
                  }}>
                    {(locationname.length === 0 || !isPersonalInfoComplete) && isResourceExpanded && (
                      show(),
                      setResourceExpanded(!isResourceExpanded)
                    )}
                    {locationname.length > 0 && (
                      <ResourceSelection
                        moveToResource={{
                          resSelected: resSelected.bind(this),
                          selectedLocation: selectedLocation,
                          newCall: true,
                          dbname: dbname,
                          resourceIds: resourceIds,
                          modes: modes,
                          resourceNames: resourceNames,
                          referralTypes: referralTypes,
                          insuranceId: isSelectedInsName,
                          targetDoctorId: targetDoctorId,
                          isResourceExpanded: isResourceExpanded,
                          selectedProvider: selectedProvider
                        }}
                      />
                    )}
                  </CardContent>
                </Collapse>
              </Card>
              {selectedProviderName.length > 0 && (
                <Paper elevation={1} style={{
                  borderRadius: "0px"
                }}>
                  {document.getElementById("doctorCard") && document.getElementById("doctorCard").classList.add(classes.activeColor)}
                  <Divider />
                  <Card onClick={expandResource}>
                    <CardContent>
                      <Typography variant="span">
                        Selected doctor : {selectedProviderName}
                      </Typography>
                    </CardContent>
                  </Card>
                </Paper>
              )}
            </Grid>

            {showApptTypePanel && (
              <Grid item xs={12} style={{
                paddingBottom: "15px"
              }}>
                <Card style={{
                  borderRadius: "0px"
                }}>
                  <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandApptType} aria-expanded={isApptTypeExpanded}>
                    <div className={classes.titleCommon}>
                      <Typography id="apptTypeCard" variant="span" className={classes.numberCircle}>4</Typography>
                      <Typography variant="span" className={classes.cardTitle}>Choose Appointment Type</Typography>
                    </div>
                  </div>
                  <Collapse in={isApptTypeExpanded}>
                    <CardContent style={{
                      marginTop: "-3%",
                    }}>
                      {(locationname.length === 0 || fname.length === 0 || selectedProviderName.length === 0) && isApptTypeExpanded && (
                        show(),
                        setApptTypeExpanded(!isApptTypeExpanded)
                      )}
                      {selectedProviderName.length > 0 && isApptTypeExpanded && (
                        <ApptTypeSelection
                          moveToApptType={{
                            apptTypeSelected: apptTypeSelected.bind(this),
                            selectedLocation: selectedLocation,
                            selectedProvider: selectedProvider,
                            newCall: true,
                            dbname: dbname,
                            modes: modes
                          }}
                        />
                      )}
                    </CardContent>
                  </Collapse>
                </Card>
                {selectedApptType.length > 0 && (
                  <Paper elevation={1} style={{
                    borderRadius: "0px"
                  }}>
                    {document.getElementById("apptTypeCard") && document.getElementById("apptTypeCard").classList.add(classes.activeColor)}
                    <Divider />
                    <Card onClick={expandApptType}>
                      <CardContent>
                        <Typography variant="span">
                          Selected Appointment Type : {selectedApptType}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Paper>
                )}
              </Grid>
            )}

            <Grid item xs={12} style={{
              paddingBottom: "15px"
            }}>
              <Card style={{
                borderRadius: "0px"
              }}>
                <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandSlots} aria-expanded={isSlotsExpanded}>
                  <div className={classes.titleCommon}>
                    <Typography id="apptCard" variant="span" className={classes.numberCircle}>{showApptTypePanel ? "5" : "4"}</Typography>
                    <Typography variant="span" className={classes.cardTitle}>Choose appointment</Typography>
                  </div>
                </div>
                <Collapse in={isSlotsExpanded} >
                  <CardContent style={{
                    marginTop: "-3%",
                  }}>
                    {(locationname.length === 0 || fname.length === 0 || selectedProviderName.length === 0 || (showApptTypePanel && selectedApptType.length === 0)) && isSlotsExpanded && (
                      show(),
                      setSlotsExpanded(!isSlotsExpanded)
                    )}
                    {(selectedProviderName.length > 0) && (
                      <BookScreen
                        changeScreen={{
                          continueToInfo: continueToInfo.bind(this),
                          selectedProvider: selectedProvider,
                          scroll: isScroll,
                          newCall: true,
                          dbname: dbname,
                          selectedApptType: selectedApptType,
                          selectedLocation: selectedLocation
                        }}
                      />
                    )}
                  </CardContent>
                </Collapse>
              </Card>
              {bookeddate.length > 0 && (
                <Paper elevation={1} style={{
                  borderRadius: "0px"
                }}>
                  {document.getElementById("apptCard") && document.getElementById("apptCard").classList.add(classes.activeColor)}
                  <Divider />
                  <Card onClick={expandSlots}>
                    <CardContent>
                      <Typography variant="span">
                        Appointment : {changeDateFormat(bookeddate)} at {changeTiming(isStartTime)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Paper>
              )}
            </Grid>

            <Grid item xs={12} style={{
              paddingBottom: "15px"
            }}>
              <Card style={{
                borderRadius: "0px"
              }}>
                <div className={[classes.cardHeader, classes.mainPanelGrid].join(" ")} onClick={expandConfirmation} aria-expanded={isConfirmExpanded}>
                  <div className={classes.titleCommon}>
                    <Typography id="reviewCard" variant="span" className={classes.numberCircle}>{showApptTypePanel ? "6" : "5"}</Typography>
                    <Typography variant="span" className={classes.cardTitle}>Confirmation</Typography>
                  </div>
                </div>
                <Collapse in={isConfirmExpanded}>
                  <CardContent style={{
                    marginTop: "-3%",
                  }}>
                    {fname != undefined && (locationname.length === 0 || selectedProviderName.length === 0 || bookeddate.length === 0 || fname.length === 0) && isConfirmExpanded && (
                      show(),
                      setConfirmExpanded(!isConfirmExpanded)
                    )}
                    {isMoveToConfirm && (
                      <ConfirmationScreen
                        confirmScreen={{
                          confirmToBook: confirmToBook.bind(this),
                          Fname: fname,
                          Lname: lname,
                          CellNum: isCellNum,
                          selecteddob: isSelectedDOB,
                          selectVisitType: isSelectVisitType,
                          selectedInsName: isSelectedInsNameValue,
                          selectedVisitReason: isSelectedVisitReasonValue,
                          aptDate: bookeddate,
                          timing: changeTiming(isStartTime),
                          location: locationname,
                          insNum: insNum,
                          resourcename: selectedProviderName,
                          selectRelationName: isSelectRelationName,
                          apptType: selectedApptType,
                          newCall: true,
                          dbname: dbname
                        }}
                      />
                    )}
                  </CardContent>
                </Collapse>
              </Card>
            </Grid>

          </Paper>
        </Grid>
      )}
      {isModalOpened && (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: '100vh' }}
        >
          <Grid item xs={6}>
            <Card>
              <CardContent>
                {errorSlotMsg ? (
                  <div>
                    <Typography variant="subtitle1" justifyContent="center" style={{
                      display: "flex",
                      alignItems: "center"
                    }}>
                      <ErrorIcon style={{
                        color: "red",
                      }} /> Your appointment has not been scheduled because you have chosen a locked slot.
                    </Typography>
                    <Typography variant="subtitle2" align="center">
                      Please contact Glenwood or try again after sometime
                    </Typography>
                  </div>
                ) : (errorApi) ? (
                  <div>
                    <Typography variant="subtitle1" justifyContent="center" style={{
                      display: "flex",
                      alignItems: "center"
                    }}>
                      <ErrorIcon style={{
                        color: "red",
                      }} /> Error while booking the appointment.
                    </Typography>
                    <Typography variant="subtitle2" align="center">
                      Please contact Glenwood or try again after sometime
                    </Typography>
                  </div>
                ) : (
                  <div>
                    <Typography variant="subtitle1" justifyContent="center" style={{
                      display: "flex",
                      alignItems: "center"
                    }}>
                      <DoneIcon style={{
                        color: "green",
                      }} />
                      {!successData ? (
                        "Appointment Booked."
                      ) : (
                        "Sent Appointment request"
                      )}
                    </Typography>

                    <div style={{
                      padding: "10px",
                    }}>
                      <Typography variant="subtitle1" >
                        Hello {fname},
                      </Typography>
                      <div style={{
                        padding: "10px",
                      }}>

                        {!successData ? (
                          <div>
                            <Typography variant="subtitle1" >
                              Your appointment with Dr. {selectedProviderName} on {changeDateFormat(bookeddate)} at {changeTiming(isStartTime)} has been confirmed.
                            </Typography>
                            <Typography variant="subtitle1" >
                              Selected location: {locationname}
                            </Typography>
                            <Typography variant="subtitle1" >
                              Please arrive 10 minutes early for your appointment and bring your insurance card and a photo ID with you.
                            </Typography>
                          </div>
                        ) : (
                          <div>
                            <Typography variant="subtitle1" >
                              Your appointment request with Dr. {selectedProviderName} on {changeDateFormat(bookeddate)} at {changeTiming(isStartTime)} has been sent successfully.
                            </Typography>
                            <Typography variant="subtitle1" >
                              Selected location: {locationname}
                            </Typography>
                            <Typography variant="subtitle1" >
                              We will confirm your appointment status through e-mail/phone shortly.
                            </Typography>
                          </div>
                        )}
                        <Typography variant="subtitle1" >
                          If you have any questions, please call us at {practiceNum}
                        </Typography>
                      </div>
                    </div>
                  </div>
                )}
              </CardContent>
              <CardActions style={{
                justifyContent: "flex-end",
              }}>
              </CardActions>
            </Card>

          </Grid>
        </Grid>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={openSnackBar}
        onClose={closeSnackBar}
        autoHideDuration={3000}  // Snackbar will auto-hide after 3 seconds
        message={snackBarMessage}  // Display the message set by show method
        key={`${openSnackBar}_${snackBarMessage}`}  // Ensure key changes to trigger updates
      />
    </div>
  );
};

export default withStyles(styles)(BookingProcess);

